import { Box } from '@material-ui/core';
import CustomB2ChatLogo from '@src/components/B2ChatLogo/CustomB2ChatLogo';
import { useB2ChatLogo } from '@src/reducers/partnerCustomUiApi';
import React from 'react';

export interface B2ChatLogoProps {
  height: number;
  b2chatLogo: string;
}

const B2ChatLogoWrapper: React.FC = () => {
  const { logoUrl, isDefault } = useB2ChatLogo();

  return (
    <Box display="flex" justifyContent="center" margin="24px 0 20px">
      {isDefault ? (
        <Box height={48} width={182}>
          <CustomB2ChatLogo />
        </Box>
      ) : (
        <img src={logoUrl} alt="B2ChatLogoDesktop" style={{ height: 40 }} />
      )}
    </Box>
  );
};

export const B2ChatLogo: React.FC<B2ChatLogoProps> = ({
  height,
  b2chatLogo,
}) => <img src={b2chatLogo} alt="B2ChatLogoDesktop" style={{ height }} />;

export default B2ChatLogoWrapper;
